import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Approach } from "@/components/Approach";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Journey } from "@/components/Journey";
import { LifeGoals } from "@/components/LifeGoals";
import { WhyUs } from "@/components/WhyUs";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/site";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => scrollToId(window.location.hash.slice(1)), 700);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  return (
    <div className="relative min-h-screen bg-[#F8F7F3] text-[#10202E]">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Approach />
        <Marquee />
        <Services />
        <Journey />
        <LifeGoals />
        <WhyUs />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
